import { useAuthLogout } from '@/app/hooks/auth/useAuthLogout'
import { isValidRedirect } from '@/app/lib/auth'
import { ROUTES } from '@/app/lib/constants'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

export default function AuthLogoutPage() {
  const { mutateAsync: logout } = useAuthLogout()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const redirectTo = searchParams.get('redirectTo') ?? ROUTES.homepage
  const product = searchParams.get('product');

  useEffect(() => {
    ; (async () => {
      try {
        await logout()
      } catch {
        // Ignore logout errors
      }



      const queryParams = new URLSearchParams()
      if (isValidRedirect(redirectTo)) {
        queryParams.set('redirectTo', redirectTo)
      }

      if (product) {
        queryParams.set('product', product)
      }

      const loginPath = queryParams.toString()
        ? `${ROUTES.login}?${queryParams.toString()}`
        : ROUTES.login

      navigate(loginPath, { replace: true })
    })()
  }, [logout, navigate, redirectTo])

  return null
}
